import { Component } from '@angular/core';

@Component({
  selector: 'app-sales-introduction-page',
  templateUrl: './sales-introduction-page.component.html',
  styleUrls: ['./sales-introduction-page.component.scss'],
})
export class SalesIntroductionPageComponent {
  /** 图片加载失败时显示文字降级 */
  onImgError(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.style.display = 'none';
    const fallback = img.nextElementSibling as HTMLElement;
    if (fallback) {
      fallback.style.display = 'inline-flex';
    }
  }
}
